/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminAdminControllerBlockV1 } from '../fn/admin-admin/admin-admin-controller-block-v-1';
import { AdminAdminControllerBlockV1$Params } from '../fn/admin-admin/admin-admin-controller-block-v-1';
import { adminAdminControllerCreateV1 } from '../fn/admin-admin/admin-admin-controller-create-v-1';
import { AdminAdminControllerCreateV1$Params } from '../fn/admin-admin/admin-admin-controller-create-v-1';
import { adminAdminControllerDeleteV1 } from '../fn/admin-admin/admin-admin-controller-delete-v-1';
import { AdminAdminControllerDeleteV1$Params } from '../fn/admin-admin/admin-admin-controller-delete-v-1';
import { adminAdminControllerFindAllV1 } from '../fn/admin-admin/admin-admin-controller-find-all-v-1';
import { AdminAdminControllerFindAllV1$Params } from '../fn/admin-admin/admin-admin-controller-find-all-v-1';
import { adminAdminControllerFindByIdV1 } from '../fn/admin-admin/admin-admin-controller-find-by-id-v-1';
import { AdminAdminControllerFindByIdV1$Params } from '../fn/admin-admin/admin-admin-controller-find-by-id-v-1';
import { adminAdminControllerFindMeV1 } from '../fn/admin-admin/admin-admin-controller-find-me-v-1';
import { AdminAdminControllerFindMeV1$Params } from '../fn/admin-admin/admin-admin-controller-find-me-v-1';
import { adminAdminControllerRefreshV1 } from '../fn/admin-admin/admin-admin-controller-refresh-v-1';
import { AdminAdminControllerRefreshV1$Params } from '../fn/admin-admin/admin-admin-controller-refresh-v-1';
import { adminAdminControllerSearchCursorV1 } from '../fn/admin-admin/admin-admin-controller-search-cursor-v-1';
import { AdminAdminControllerSearchCursorV1$Params } from '../fn/admin-admin/admin-admin-controller-search-cursor-v-1';
import { adminAdminControllerSearchOffsetV1 } from '../fn/admin-admin/admin-admin-controller-search-offset-v-1';
import { AdminAdminControllerSearchOffsetV1$Params } from '../fn/admin-admin/admin-admin-controller-search-offset-v-1';
import { adminAdminControllerSignInV1 } from '../fn/admin-admin/admin-admin-controller-sign-in-v-1';
import { AdminAdminControllerSignInV1$Params } from '../fn/admin-admin/admin-admin-controller-sign-in-v-1';
import { adminAdminControllerSignOutV1 } from '../fn/admin-admin/admin-admin-controller-sign-out-v-1';
import { AdminAdminControllerSignOutV1$Params } from '../fn/admin-admin/admin-admin-controller-sign-out-v-1';
import { adminAdminControllerUnblockV1 } from '../fn/admin-admin/admin-admin-controller-unblock-v-1';
import { AdminAdminControllerUnblockV1$Params } from '../fn/admin-admin/admin-admin-controller-unblock-v-1';
import { adminAdminControllerUpdateV1 } from '../fn/admin-admin/admin-admin-controller-update-v-1';
import { AdminAdminControllerUpdateV1$Params } from '../fn/admin-admin/admin-admin-controller-update-v-1';
import { AdminDto } from '../models/admin-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class AdminAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminAdminControllerFindAllV1()` */
  static readonly AdminAdminControllerFindAllV1Path = '/api/v1/admins/admin';

  /**
   * 관리자 전체 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerFindAllV1$Response(params?: AdminAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminDto>>> {
    const obs = adminAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 전체 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerFindAllV1(params?: AdminAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<AdminDto>> {
    const resp = this.adminAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AdminDto>>): Array<AdminDto> => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerCreateV1()` */
  static readonly AdminAdminControllerCreateV1Path = '/api/v1/admins/admin';

  /**
   * 관리자 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminAdminControllerCreateV1$Response(params: AdminAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminAdminControllerCreateV1(params: AdminAdminControllerCreateV1$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerSearchOffsetV1()` */
  static readonly AdminAdminControllerSearchOffsetV1Path = '/api/v1/admins/admin/search/offset';

  /**
   * 관리자 오프셋 기반 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerSearchOffsetV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerSearchOffsetV1$Response(params: AdminAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<AdminDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = adminAdminControllerSearchOffsetV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 오프셋 기반 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerSearchOffsetV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerSearchOffsetV1(params: AdminAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<{
'items': Array<AdminDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.adminAdminControllerSearchOffsetV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<AdminDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<AdminDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerSearchCursorV1()` */
  static readonly AdminAdminControllerSearchCursorV1Path = '/api/v1/admins/admin/search/cursor';

  /**
   * 관리자 커서 기반 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerSearchCursorV1$Response(params: AdminAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<AdminDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = adminAdminControllerSearchCursorV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 커서 기반 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerSearchCursorV1(params: AdminAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<{
'items': Array<AdminDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.adminAdminControllerSearchCursorV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<AdminDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<AdminDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerFindMeV1()` */
  static readonly AdminAdminControllerFindMeV1Path = '/api/v1/admins/admin/me';

  /**
   * 현재 관리자 조회.
   *
   * 현재 로그인한 관리자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerFindMeV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerFindMeV1$Response(params?: AdminAdminControllerFindMeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminAdminControllerFindMeV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 현재 관리자 조회.
   *
   * 현재 로그인한 관리자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerFindMeV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerFindMeV1(params?: AdminAdminControllerFindMeV1$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminAdminControllerFindMeV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerFindByIdV1()` */
  static readonly AdminAdminControllerFindByIdV1Path = '/api/v1/admins/admin/{id}';

  /**
   * 관리자 단건 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerFindByIdV1$Response(params: AdminAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 단건 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerFindByIdV1(params: AdminAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerDeleteV1()` */
  static readonly AdminAdminControllerDeleteV1Path = '/api/v1/admins/admin/{id}';

  /**
   * 관리자 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerDeleteV1$Response(params: AdminAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerDeleteV1(params: AdminAdminControllerDeleteV1$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerUpdateV1()` */
  static readonly AdminAdminControllerUpdateV1Path = '/api/v1/admins/admin/{id}';

  /**
   * 관리자 정보 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminAdminControllerUpdateV1$Response(params: AdminAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 정보 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminAdminControllerUpdateV1(params: AdminAdminControllerUpdateV1$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerSignInV1()` */
  static readonly AdminAdminControllerSignInV1Path = '/api/v1/admins/admin/signin';

  /**
   * 관리자 로그인.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerSignInV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminAdminControllerSignInV1$Response(params: AdminAdminControllerSignInV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;

/**
 * 리프레시 토큰
 */
'refreshToken'?: string;
}>> {
    const obs = adminAdminControllerSignInV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 로그인.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerSignInV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminAdminControllerSignInV1(params: AdminAdminControllerSignInV1$Params, context?: HttpContext): Observable<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;

/**
 * 리프레시 토큰
 */
'refreshToken'?: string;
}> {
    const resp = this.adminAdminControllerSignInV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;

/**
 * 리프레시 토큰
 */
'refreshToken'?: string;
}>): {

/**
 * 액세스 토큰
 */
'accessToken'?: string;

/**
 * 리프레시 토큰
 */
'refreshToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerSignOutV1()` */
  static readonly AdminAdminControllerSignOutV1Path = '/api/v1/admins/admin/signout';

  /**
   * 관리자 로그아웃.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerSignOutV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerSignOutV1$Response(params?: AdminAdminControllerSignOutV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = adminAdminControllerSignOutV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 로그아웃.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerSignOutV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerSignOutV1(params?: AdminAdminControllerSignOutV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.adminAdminControllerSignOutV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerRefreshV1()` */
  static readonly AdminAdminControllerRefreshV1Path = '/api/v1/admins/admin/refresh';

  /**
   * 관리자 토큰 재발급.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerRefreshV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminAdminControllerRefreshV1$Response(params: AdminAdminControllerRefreshV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;
}>> {
    const obs = adminAdminControllerRefreshV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 토큰 재발급.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerRefreshV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminAdminControllerRefreshV1(params: AdminAdminControllerRefreshV1$Params, context?: HttpContext): Observable<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;
}> {
    const resp = this.adminAdminControllerRefreshV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{

/**
 * 액세스 토큰
 */
'accessToken'?: string;
}>): {

/**
 * 액세스 토큰
 */
'accessToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerBlockV1()` */
  static readonly AdminAdminControllerBlockV1Path = '/api/v1/admins/admin/{id}/block';

  /**
   * 관리자 차단.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerBlockV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerBlockV1$Response(params: AdminAdminControllerBlockV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminAdminControllerBlockV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 차단.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerBlockV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerBlockV1(params: AdminAdminControllerBlockV1$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminAdminControllerBlockV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminAdminControllerUnblockV1()` */
  static readonly AdminAdminControllerUnblockV1Path = '/api/v1/admins/admin/{id}/unblock';

  /**
   * 관리자 차단 해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminAdminControllerUnblockV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerUnblockV1$Response(params: AdminAdminControllerUnblockV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    const obs = adminAdminControllerUnblockV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 관리자 차단 해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminAdminControllerUnblockV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminAdminControllerUnblockV1(params: AdminAdminControllerUnblockV1$Params, context?: HttpContext): Observable<AdminDto> {
    const resp = this.adminAdminControllerUnblockV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

}
